import { useTranslation } from 'next-i18next';
import styles from '@features/cms/components/collections/ProductGalleryBlock/ProductGalleryBlockSlide/ProductGalleryBlockSlide.styles';
import { IParsedImage } from '@components/typescript';
import ResponsiveImage from '@components/ResponsiveImage/ResponsiveImage';
type PropsType = {
  image: IParsedImage;
  alt?: string;
};
const ProductGalleryBlockSlide = ({
  image,
  alt = ''
}: PropsType) => {
  const {
    t
  } = useTranslation('common');
  if (!image.image.desktop) return <></>;
  return <div sx={styles.imageSlide}>
      <ResponsiveImage image={image.image} blur={image.blur} alt={alt || t('accessibility.productPhoto')} sx={styles.imageSlide.img} />
    </div>;
};
export default ProductGalleryBlockSlide;